import { useCallback, useRef, useEffect } from "react";
import { useProjectTree, getTreeApi } from "stores/project";

export const useSmoothScroll = ({ windowHeight }: { windowHeight: number }) => {
  const projectTree = useProjectTree();
  const scrollToIndex = useRef<number | null>(null);
  const scrollOffsetRef = useRef(0);
  const setScrollToIndex = useCallback((index: number) => {
    scrollToIndex.current = index;
  }, []);

  const setScrollOffset = useCallback((offset: number) => {
    scrollOffsetRef.current = offset;
  }, []);

  useEffect(() => {
    if (scrollToIndex.current !== null) {
      const index = scrollToIndex.current;
      const treeApi = getTreeApi();

      const listRef = treeApi?.list;
      if (!listRef || !listRef.current) {
        return;
      }

      const itemOffset = listRef.current._getItemStyle(index).top;
      const itemHeight = listRef.current._getItemStyle(index).height;

      const scrollOffset = scrollOffsetRef.current;
      if (
        itemOffset >= scrollOffset &&
        itemOffset + itemHeight <= scrollOffset + windowHeight
      ) {
        return;
      }

      const top = itemOffset + itemHeight - windowHeight / 2;

      if (top < 0) {
        return;
      }

      listRef.current._outerRef.scrollTo({
        top,
        behavior: "smooth",
      });
      scrollToIndex.current = null;
    }
  }, [windowHeight, projectTree, scrollToIndex]);

  return {
    setScrollToIndex,
    setScrollOffset,
  };
};
